import React, { useMemo } from "react";
import { Col, Row, Card, CardBody, Button } from "reactstrap";
import { toast } from "react-toastify";

import TableContainer from "components/Common/TableContainer";
import Breadcrumbs from "components/Common/Breadcrumb";
import GlobalInputSearch from "components/Common/GlobalInputSearch";

import { useModules } from "hooks/useRolePermission";
import { useListParams } from "hooks/useListParams";
import { formatReadableDate } from "utils/formatDate";

const ModuleList = () => {
  document.title = "Module List";

  const { params, setPage, setSearch, resetParams, hasActiveFilters } = useListParams({ page: 1, search: "" });

  const queryParams = useMemo(
    () => ({
      page: params.page,
      per_page: 10,
      ...(params.search && { search: params.search }),
    }),
    [params.page, params.search]
  );

  const {
    data: moduleResponse,
    isLoading,
    refetch: moduleRefetch,
    isRefetching: moduleRefetchLoading,
  } = useModules(queryParams);

  const handleModuleListRefresh = () => {
    moduleRefetch();
    toast.info("Module list refreshed.");
  };

  const columns = useMemo(
    () => [
      { header: "ID", accessorKey: "id" },
      { header: "Name", accessorKey: "name" },
      { header: "Slug", accessorKey: "slug" },
      { header: "Description", accessorKey: "description" },
      {
        header: "Created",
        accessorKey: "created_at",
        cell: ({ row }) =>
          row.original.created_at ? formatReadableDate(row.original.created_at) : "-",
      },
    ],
    []
  );

  const modulesData = moduleResponse?.data?.data || [];
  const paginationInfo = moduleResponse?.data;

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Module" breadcrumbItem="Module List" />
        <Row>
          <Col lg="12">
            <Card>
              <CardBody className="border-bottom d-flex align-items-center">
                <h5 className="mb-0 card-title flex-grow-1">Module Lists</h5>
                <div className="flex-shrink-0">
                  <Button
                    color="light"
                    onClick={handleModuleListRefresh}
                    className="me-1"
                  >
                    <i
                      className={`mdi mdi-refresh ${
                        moduleRefetchLoading ? "mdi-spin" : ""
                      }`}
                    />
                  </Button>
                  {hasActiveFilters && (
                    <Button color="danger" onClick={resetParams}>
                      <i className="mdi mdi-close" /> Reset Filters
                    </Button>
                  )}
                </div>
              </CardBody>

              <CardBody>
                <Row className="mb-3">
                  <Col sm={4}>
                    <GlobalInputSearch value={params.search} onChange={setSearch} />
                  </Col>
                </Row>

                <TableContainer
                  columns={columns}
                  data={modulesData}
                  isPagination
                  paginationInfo={paginationInfo}
                  onPageChange={setPage}
                  loading={isLoading || moduleRefetchLoading}
                  tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ModuleList;
